import { render } from "./purchasesBill.vue?vue&type=template&id=89c84c1c&scoped=true"
import script from "./purchasesBill.vue?vue&type=script&lang=js"
export * from "./purchasesBill.vue?vue&type=script&lang=js"

import "./purchasesBill.vue?vue&type=style&index=0&id=89c84c1c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89c84c1c"]])

export default __exports__